import common from './common.json';
import auth from './auth.json';
import errors from './errors.json';
import admin from './admin.json';
import customer from './customer.json';
import enums from './enums.json';
import crm from './crm.json';
import pipeline from './pipeline.json';
import meetings from './meetings.json';
import meetingPools from './meetingPools.json';
import dashboard from './dashboard.json';
import apiKeys from './apiKeys.json';
import notifications from './notifications.json';
import callcenter from './callcenter.json';
import dealOutcome from './dealOutcome.json';

const deDE = {
  common,
  auth,
  errors,
  admin,
  enums,
  customer,
  crm,
  pipeline,
  meetings,
  meetingPools,
  dashboard,
  apiKeys,
  notifications,
  callcenter,
  dealOutcome,
};

export default deDE;
